module.exports = __webpack_public_path__ + "img/banner.3850cc5b.png";